import React from 'react'
import { FieldArray } from 'formik'
import { reducer } from './utils'

import * as El from '../styles'

export default class CheckboxInput extends React.Component {
  resetCheckboxes = e => {
    const s = e.target.name.split('.')
    if (!reducer(this.props.formik.values, e.target.name)) {
      this.props.formik.values[s[0]][s[1]] = null
    }
    this.props.formik.handleChange(e)
  }

  resetDefault = e => {
    this.props.formik.handleChange(e)
    const s = e.target.name.split('.')
    if (!reducer(this.props.formik.values, e.target.name)) {
      this.props.formik.values[s[0]][s[1]]['default'] = false
    }
  }

  render () {
    const { name, form_s } = this.props
    const { errors, touched, values } = this.props.formik
    const element = reducer(form_s, name)
    const error = reducer(errors, name)
    const touch = reducer(touched, name)
    return (
      <FieldArray
        name={name}
        render={() => (
          <div>
            <El.Title error={(error && touch) || null}>
              {element.title}
            </El.Title>
            <El.Group>
              <El.Label>
                {element.default}
                <El.Checkbox
                  name={`${name}.default`}
                  onChange={this.resetCheckboxes}
                  type='checkbox'
                  checked={reducer(values, `${name}.default`)}
                />
                <El.Checkmark />
              </El.Label>
              {element.values.map((e, i) => (
                <El.Label key={i}>
                  {e}
                  <El.Checkbox
                    name={name + '.' + e}
                    onChange={this.resetDefault}
                    type='checkbox'
                    checked={reducer(values, name + '.' + e)}
                  />
                  <El.Checkmark />
                </El.Label>
              ))}
              {error && touch && <El.Error>{reducer(errors, name)}</El.Error>}
            </El.Group>
          </div>
        )}
      />
    )
  }
}
